import type { LocationGenerics } from "@/router/locationGenerics";
import { lazyRouteElement } from "@/router/lazyRouteElement";

import { EltSyncBreadcrumb } from "@/components/elements/breadcrumbs/EltSyncBreadcrumb";
import LoadingError from "@/components/elements/routing/LoadingError";
import { ApolloClient } from "@apollo/client";
import { Navigate, Outlet, Route } from "@tanstack/react-location";

export const dataSourcesRoute = (
  _client: ApolloClient<object>,
): Route<LocationGenerics> => {
  return {
    path: "sources",
    element: <Outlet />,
    meta: {
      breadcrumb: () => "Data Sources",
    },
    children: [
      {
        path: "usage",
        element: <Navigate to="../../settings/usage" hash="data-sources" />,
      },
      {
        path: ":syncId",
        meta: {
          breadcrumb: ({ syncId }) => <EltSyncBreadcrumb syncId={syncId} />,
        },
        children: [
          {
            path: "configuration",
            element: lazyRouteElement(() =>
              import("./EditEltSync").then((m) => <m.default />),
            ),
            meta: {
              breadcrumb: () => "Configuration",
            },
          },
          {
            // Redirect to `/sources` and open sync slide-over
            element: ({ params }) =>
              Promise.resolve(
                <Navigate<LocationGenerics>
                  to=".."
                  search={{
                    viewDataSource: { syncId: params.syncId },
                  }}
                />,
              ),
            errorElement: <LoadingError />,
          },
        ],
      },
      {
        element: lazyRouteElement(() =>
          import("./EltSyncsPage").then((m) => <m.default />),
        ),
      },
    ],
  };
};
